export const ADMIN_FILTER = [
  { value: "admin", label: "Admin",key:'search_role' },
  { value: "superadmin", label: "Super Admin",key:'search_role' },
];

export const BOOKING_FILTER = [
  { label: "Completed", value: "Completed",key:'booking_status'},
  { label: "Cancelled", value: "Cancelled",key:'booking_status'},
  { label: "Upcoming", value: "Upcoming",key:'booking_status'},
];

export const OPERATOR_FILTER = [
  { value: "active", label: "Active",key:'status' },
  { value: "inactive", label: "In Active",key:'status' },
];

export const COUPON_FILTER = [
  { value: "active", label: "Active", key: "status" },
  { value: "in-active", label: "In Active", key: "status" },
];

export const SETTLEMENT_FILTER = [
  { value: "pending", label: "Pending", key: "settled_status" },
  { value: "failed", label: "Failed", key: "settled_status" },
  { value: "settled", label: "Settled", key: "settled_status" },
];

export const TRANSACTION_FILTER = [
  { label: "Customer Name", value: "customer_name" },
  { label: "Customer ID", value: "customer_id" },
  { label: "Customer Contact", value: "customer_contact" },
  { label: "Transaction ID", value: "transaction_id" },
];
